import { Component, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  DxButtonModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxValidationGroupComponent,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ReportContent } from '../../core/models/report-content';
import { stripAllTags } from '../helpers/dom';
import { ScrollViewWithBottomBarComponent } from '~/app/shared/components/scroll-view-with-bottom-bar.component';
import { AppButtonComponent } from '~/app/shared/components/app-button.component';

import { ReportContentService } from '~/app/core/services/backend/report-content.service';
import { AuthService } from '~/app/core/auth/services/authentication.service';
import { LayoutService } from '~/app/core/services/store/layout.service';

@Component({
  selector: 'app-content-report',
  templateUrl: './content-report.component.html',
  imports: [
    ScrollViewWithBottomBarComponent,
    DxValidationGroupModule,
    TranslateModule,
    DxTextAreaModule,
    DxValidatorModule,
    DxTextBoxModule,
    DxButtonModule,
    AppButtonComponent,
  ],
})
export class ContentReportComponent implements OnInit, OnDestroy {
  @ViewChild('contentReportVG', { static: false }) public contentReportVG?: DxValidationGroupComponent;

  @Output() public closeContentReport = new EventEmitter();
  public report?: ReportContent;
  public visible?: boolean;

  public isLoggedIn = false;

  public stripAllTags = stripAllTags;
  private subscriptions: Array<Subscription> = [];

  public translateService = inject(TranslateService);
  public reportContentService = inject(ReportContentService);
  private authService = inject(AuthService);
  private layoutService = inject(LayoutService);

  public ngOnInit() {
    this.subscriptions = [
      this.layoutService.isReportDialogShown.subscribe((visible) => {
        this.visible = visible;
      }),
      this.layoutService.reportDialogContentReport.subscribe((report) => {
        this.report = report || undefined;
      }),
      this.authService
        .isLoggedIn()
        .pipe(distinctUntilChanged())
        .subscribe((isLoggedIn) => {
          this.isLoggedIn = isLoggedIn;
        }),
    ];
  }

  public ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions = [];
  }

  public send() {
    if (this.contentReportVG?.instance.validate().isValid) {
      if (!this.report) return;
      this.reportContentService.post(this.report).subscribe(() => {
        this.closeContentReport.emit();
        this.reset();
      });
    }
  }

  public close() {
    this.reset();
    this.closeContentReport.emit();
  }

  public reset() {
    // must create dummy Object, so that reset call can set a meaningless value on something.
    // Despite the ngIf taking the node out of dom, the handler is still gets called and tries to set a property on null object
    this.report = new ReportContent();
    this.contentReportVG?.instance.reset();
    this.report = undefined;
  }
}
